
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Popover,
  Position,
  Button,
  Color,
  Flex,
  FlexItem,
  Size,
  Margin,
  Icon,
  ListTile,
  Text,
  Avatar,
  Category,
} from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Popover`}</h1>
<p>{`It can be used to wrap any component/element and display a hint when `}<em parentName="p">{`clicked`}</em>{`. The component is uncontrolled and uses portals to be rendered on top of the content.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Popover } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Flex>
  <FlexItem>
    <Margin size={{ right: Size.LARGE }}>
      <Popover content="I am a popover">
        <Button category={Category.BRAND}>Click me</Button>
      </Popover>
    </Margin>
  </FlexItem>
  <FlexItem>
    <Popover
      content={
        <div style={{ textAlign: 'left' }}>
          <Margin size={{ bottom: Size.EXTRA_SMALL }}>
            <ListTile leading={<Icon name="alert-triangle" color={Color.RED} />} title={<Text size={Size.SMALL} inversed>I'm custom content</Text>} />
          </Margin>
          <ListTile leading={<Icon name="check-circle" color={Color.GREEN} />} title={<Text size={Size.SMALL} inversed>So am I</Text>} />
        </div>
      }>
      <Avatar color={Color.GREEN} text="PO" />
    </Popover>
  </FlexItem>
</Flex>`} component={Popover} mdxType="Playground">
  <Flex mdxType="Flex">
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.LARGE
          }} mdxType="Margin">
        <Popover content="I am a popover" mdxType="Popover">
          <Button category={Category.BRAND} mdxType="Button">Click me</Button>
        </Popover>
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Popover content={<div style={{
            textAlign: 'left'
          }}>
            <Margin size={{
              bottom: Size.EXTRA_SMALL
            }} mdxType="Margin">
              <ListTile leading={<Icon name="alert-triangle" color={Color.RED} mdxType="Icon" />} title={<Text size={Size.SMALL} inversed mdxType="Text">I'm custom content</Text>} mdxType="ListTile" />
            </Margin>
            <ListTile leading={<Icon name="check-circle" color={Color.GREEN} mdxType="Icon" />} title={<Text size={Size.SMALL} inversed mdxType="Text">So am I</Text>} mdxType="ListTile" />
          </div>} mdxType="Popover">
        <Avatar color={Color.GREEN} text="PO" mdxType="Avatar" />
      </Popover>
    </FlexItem>
  </Flex>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;